import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    // 1. IMPEDE O RELOAD DA PÁGINA (Mantém o estado do React)
    e.preventDefault(); 

    try {
      const response = await axios.post('https://newsletter.dizycommerce.com.br/api/login', { email, password });

      if (response.data.success) {
        // 2. SALVA O USUÁRIO E O ROLE (ADMIN/USER) PARA O BOTÃO DE ADMIN APARECER
        sessionStorage.setItem('user', JSON.stringify(response.data.user));
        
        // 3. Salva o token para as buscas do Dashboard não falharem
        sessionStorage.setItem('jwtToken', 'token-manual-2026');

        // 4. DIRECIONA PARA O PAINEL
        navigate('/lojas');
      }
    } catch (error) {
      alert(error.response?.data?.message || "Erro ao conectar com o servidor");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginCard}>
        <h2 style={styles.title}>Acesso ao Sistema</h2>
        <p style={styles.subtitle}>Newsletter 2.0 & PDF Editor</p>
        
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <input 
              style={styles.input}
              type="email" 
              placeholder="E-mail" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
            />
          </div>
          
          <div style={styles.inputGroup}>
            <input 
              style={styles.input}
              type="password" 
              placeholder="Senha" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>
          
          <button 
            type="submit" 
            style={styles.button}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1557b0'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#1a73e8'}
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
};

// Estilização Restaurada
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
    fontFamily: 'Arial, sans-serif',
  },
  loginCard: {
    backgroundColor: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  title: {
    color: '#1a73e8',
    marginBottom: '10px',
    fontSize: '28px',
  },
  subtitle: {
    color: '#666',
    marginBottom: '30px',
    fontSize: '14px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputGroup: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  input: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    outline: 'none',
  },
  button: {
    padding: '12px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: '#1a73e8',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

export default Login;
